import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PageLayout, PageContentPreloader } from 'common/components';

import { getLiquidCashbackIframeUrl } from '../../_redux';
import staticStyles from './style';

const CashbackPage = ({ iframeUrl, iframeUrlIsLoaded, getLiquidCashbackIframeUrl }) => {
  useEffect(() => {
    getLiquidCashbackIframeUrl();
  }, [getLiquidCashbackIframeUrl]);

  return (
    <PageLayout captionSlug="justCashback">
      <div className="CashbackPage">
        <PageContentPreloader ready={iframeUrlIsLoaded} type="bigLine">
          {iframeUrl && <iframe className="CashbackPage__iframe" src={iframeUrl} title="cashback" frameBorder="0" />}
        </PageContentPreloader>
      </div>
      <style jsx global>
        {staticStyles}
      </style>
    </PageLayout>
  );
};

CashbackPage.propTypes = {
  iframeUrl: PropTypes.string,
  iframeUrlIsLoaded: PropTypes.bool.isRequired,
  getLiquidCashbackIframeUrl: PropTypes.func.isRequired,
};

CashbackPage.defaultProps = {
  iframeUrl: null,
};

export default connect(
  state => ({
    iframeUrl: state.client.cashback.iframeUrl,
    iframeUrlIsLoaded: state.client.cashback.iframeUrlIsLoaded,
  }),
  {
    getLiquidCashbackIframeUrl: () => getLiquidCashbackIframeUrl.request(),
  }
)(CashbackPage);
